import { render, staticRenderFns } from "./OutboundTransferBatchDetails.template.vue?vue&type=template&id=1c9b1db5&scoped=true&"
var script = {}
import style0 from "./OutboundTransferBatchDetails.template.vue?vue&type=style&index=0&id=1c9b1db5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9b1db5",
  null
  
)

export default component.exports